export enum ClassEnum {
    XI = 'XI',
    XII = 'XII'
}
